import { http } from 'vue'

export default {
  // edit rent_invoice at the API server
  putRentInvoice (context, params = {}) {
    return http.put('rent_invoices/' + params.id, params.data)
  },
  // edit rent_invoice at the API server
  removeBillingRentInvoice (context, params = {}) {
    return http.put('rent_invoices/remove_billing/' + params.id)
  },
  // load rent details from the API server
  loadRentDetails (context, params = {}) {
    let withParam = (params.with) ? '&with=' + params.with : ''
    return http.get('rents/' + params.rentId + '?company_id=' + params.companyId + withParam)
  },
  // load rents from the API server
  loadRents (context, params = {}) {
    let pageParam = '&page=' + ((params.page) ? params.page : 1)
    let perPageParam = '&per_page=' + ((params.perPage) ? params.perPage : 50)
    let statusParam = (params.statusId) ? '&status_id=' + params.statusId : ''
    let typeParam = (params.type) ? '&type=' + params.type : ''
    let typeRentParam = (params.typeRent) ? '&type_rent=' + params.typeRent : ''
    let searchParam = (params.search) ? '&search=' + params.search : ''
    return http.get('rents?company_id=' + params.companyId + pageParam + perPageParam + statusParam + typeParam + typeRentParam + searchParam)
  },
  // create rent at the API server
  postRent (context, params = {}) {
    return http.post('rents', params.data)
  },
  // change rent at the API server
  putRent (context, params = {}) {
    return http.put('rents/' + params.rentId, params.data)
  },
  // create a new status on rent at the API server
  postRentStatus (context, params = {}) {
    return http.post('rent_status', params.data)
  },
  // change patrimony from rent at the API server
  postChangeRentIdentifier (context, params = {}) {
    return http.post('dashboard/rents/change_identifier', params.data)
  },
  // get the quantity of rents of each status
  loadRentsStatusQuantity (context, params = {}) {
    return http.get('dashboard/rents/quantity?company_id=' + params.companyId)
  },
  loadRentsTodayDelivery (context, params = {}) {
    return http.get('dashboard/rents/delivery?company_id=' + params.companyId)
  },
  // get data of the Home Rents By Type Chart
  loadRentsStartedByType (context, params = {}) {
    return http.get('dashboard/rents/chart_rents_started_by_type?company_id=' + params.companyId)
  },
  // get data of the Home Rents By Year Chart
  loadRentsByYears (context, params = {}) {
    return http.get('dashboard/rents/chart_rents_by_years?company_id=' + params.companyId)
  },
  loadRegistrationsAnalysis (context, params = {}) {
    return http.get('dashboard/clients/registrations_analysis?company_id=' + params.companyId)
  },
  // get data of the Home Registrations By Status Chart
  loadRegistrationsByStatus (context, params = {}) {
    return http.get('dashboard/clients/chart_registrations_by_status?company_id=' + params.companyId)
  },
  // get data of the Home Registrations By Year Chart
  loadRegistrationsByYears (context, params = {}) {
    return http.get('dashboard/clients/chart_registrations_by_years?company_id=' + params.companyId)
  },
  loadAvgRegistrationsTime (context, params = {}) {
    return http.get('dashboard/clients/avg_registration_time?company_id=' + params.companyId)
  },
  // refund rent_invoice at the API server
  putRefundRentInvoice (context, params = {}) {
    return http.put('refundRentInvoices/' + params.id, params.data)
  },
  // change period Rent at the API server
  changePeriodRent (context, params = {}) {
    return http.put('change_rent_period/' + params.rentId, params)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/rents/actions.js